/**
 * init.js — Bootstrap dell'applicazione al caricamento del DOM.
 * Dipende da: tutti gli altri moduli (caricato per ultimo).
 */

// Callback chiamata da Google Maps API (parametro &callback=initAutocomplete)
function initAutocomplete() {
    if (typeof google === 'undefined') return;
    const lazioBounds = new google.maps.LatLngBounds(
        new google.maps.LatLng(41.0, 11.4),
        new google.maps.LatLng(42.8, 14.0)
    );
    const opts = {
        types:                ['geocode', 'establishment'],
        fields:               ['address_components', 'formatted_address', 'geometry', 'types'],
        componentRestrictions: { country: 'it' },
        bounds:               lazioBounds,
        strictBounds:         true,
    };

    const daInput = document.getElementById('daInput');
    const aInput  = document.getElementById('aInput');

    if (daInput) {
        const ac = new google.maps.places.Autocomplete(daInput, opts);
        ac.addListener('place_changed', () => {
            const place = ac.getPlace();
            if (!place.geometry) return;
            BookingState.start_address       = place.formatted_address || daInput.value;
            BookingState.start_address_lat   = place.geometry.location.lat().toString();
            BookingState.start_address_lng   = place.geometry.location.lng().toString();
            BookingState.start_address_types = place.types || [];
            if (!checkAddressRegion(place, daInput, 'start')) return;
            fetchRouteMap();
            triggerAvailabilityCheck();
        });
        daInput.addEventListener('input', () => {
            BookingState.start_address       = '';
            BookingState.start_address_lat   = '';
            BookingState.start_address_lng   = '';
            BookingState.start_address_types = [];
        });
    }

    if (aInput) {
        const ac = new google.maps.places.Autocomplete(aInput, opts);
        ac.addListener('place_changed', () => {
            const place = ac.getPlace();
            if (!place.geometry) return;
            BookingState.end_address       = place.formatted_address || aInput.value;
            BookingState.end_address_lat   = place.geometry.location.lat().toString();
            BookingState.end_address_lng   = place.geometry.location.lng().toString();
            BookingState.end_address_types = place.types || [];
            if (!checkAddressRegion(place, aInput, 'end')) return;
            fetchRouteMap();
            triggerAvailabilityCheck();
        });
        aInput.addEventListener('input', () => {
            BookingState.end_address       = '';
            BookingState.end_address_lat   = '';
            BookingState.end_address_lng   = '';
            BookingState.end_address_types = [];
        });
    }
}

// Legge i parametri dall'hash (#tipo=...&da_address=...&a_address=...&start_date=...)
// e precompila il form al caricamento della pagina (usato con snipped.html)
function applyHashParams() {
    const hash = window.location.hash.slice(1);
    if (!hash) return;

    const params = {};
    hash.split('&').forEach(part => {
        const eq = part.indexOf('=');
        if (eq > -1) params[decodeURIComponent(part.slice(0, eq))] = decodeURIComponent(part.slice(eq + 1));
    });

    // Normalizza andata_ritorno generico → andata_ritorno_attesa
    if (params.type === 'andata_ritorno' || params.type === 'andata-ritorno') params.type = 'andata_ritorno_attesa';

    // Tipo tratta → seleziona il radio corretto e aggiorna UI
    const typeToRadioId = {
        andata:                    'trattaAndata',
        andata_ritorno_attesa:     'trattaAR',
        andata_ritorno_richiamata: 'trattaAR',
        andata_ritorno_orari_def:  'trattaAR',
    };
    if (params.type && typeToRadioId[params.type]) {
        const radio = document.getElementById(typeToRadioId[params.type]);
        if (radio) { radio.checked = true; toggleAndataRitorno(radio.value); }

        if (params.type === 'andata_ritorno_richiamata') {
            const r = document.querySelector('input[name="modalitaRitorno"][value="richiamata"]');
            if (r) { r.checked = true; updateLabelOrarioRitorno('richiamata'); }
        } else if (params.type === 'andata_ritorno_orari_def') {
            const r = document.querySelector('input[name="modalitaRitorno"][value="prestabilito"]');
            if (r) { r.checked = true; updateLabelOrarioRitorno('prestabilito'); }
        }
        collectStep1();
    }

    // Indirizzo di partenza
    if (params.da_address) {
        const el = document.getElementById('daInput');
        if (el) el.value = params.da_address;
        BookingState.start_address = params.da_address;
    }
    if (params.da_lat) BookingState.start_address_lat = params.da_lat;
    if (params.da_lng) BookingState.start_address_lng = params.da_lng;

    // Indirizzo di destinazione
    if (params.a_address) {
        const el = document.getElementById('aInput');
        if (el) el.value = params.a_address;
        BookingState.end_address = params.a_address;
    }
    if (params.a_lat) BookingState.end_address_lat = params.a_lat;
    if (params.a_lng) BookingState.end_address_lng = params.a_lng;

    // Se entrambe le coordinate sono disponibili, genera la mappa
    if (params.da_lat && params.da_lng && params.a_lat && params.a_lng) {
        fetchRouteMap();
    }

    // Data di partenza (formato dd/mm/yyyy proveniente dallo snippet)
    if (params.start_date) {
        if (typeof $ !== 'undefined' && $.fn.datepicker) {
            $('#dataPartenza').datepicker('setDate', params.start_date);
        } else {
            const el = document.getElementById('dataPartenza');
            if (el) el.value = params.start_date;
        }
        BookingState.start_date = normalizeDate(params.start_date);
        triggerAvailabilityCheck();
    }
}

// Pre-compila BookingState e tutti i campi DOM con i dati di test
function applyTestData() {
    if (!ENV.IS_TEST) return;
    const t = ENV.TEST_BOOKING;
    Object.assign(BookingState, {
        reservation_type:   t.reservation_type,
        start_date:         t.start_date,
        return_date:        t.return_date,
        start_time:         t.start_time,
        return_time:        t.return_time,
        start_address:      t.start_address,
        start_address_lat:  t.start_address_lat,
        start_address_lng:  t.start_address_lng,
        start_address_opts: { ...t.start_address_opts },
        end_address:        t.end_address,
        end_address_lat:    t.end_address_lat,
        end_address_lng:    t.end_address_lng,
        end_address_opts:   { ...t.end_address_opts },
        seat:               t.seat,
        seat_guest:         t.seat_guest,
        client:             { ...t.client },
        fly_number:         t.fly_number,
        train_name:         t.train_name,
        boat_name:          t.boat_name,
    });
    readyForTrack = true;

    // ── Tipo tratta ──────────────────────────────────────────────
    const isAR = t.reservation_type.startsWith('andata_ritorno');
    const radio = document.getElementById(isAR ? 'trattaAR' : 'trattaAndata');
    if (radio) { radio.checked = true; toggleAndataRitorno(radio.value); }

    if (isAR) {
        const modalitaVal = {
            andata_ritorno_attesa:     'attesa',
            andata_ritorno_richiamata: 'richiamata',
            andata_ritorno_orari_def:  'prestabilito',
        }[t.reservation_type] || 'attesa';
        const mr = document.querySelector(`input[name="modalitaRitorno"][value="${modalitaVal}"]`);
        if (mr) { mr.checked = true; updateLabelOrarioRitorno(modalitaVal); }
    }

    // ── Date ─────────────────────────────────────────────────────
    if (typeof $ !== 'undefined' && $.fn.datepicker) {
        $('#dataPartenza').datepicker('setDate', t.start_date);
        if (isAR && t.return_date) $('#dataRitorno').datepicker('setDate', t.return_date);
    } else {
        const dp = document.getElementById('dataPartenza');
        if (dp) dp.value = t.start_date;
        const dr = document.getElementById('dataRitorno');
        if (dr && isAR) dr.value = t.return_date;
    }

    // ── Orari ────────────────────────────────────────────────────
    const oraP = document.getElementById('oraPartenza');
    if (oraP) oraP.value = t.start_time;
    const oraR = document.getElementById('oraRitorno');
    if (oraR) oraR.value = t.return_time;

    // ── Indirizzi ────────────────────────────────────────────────
    const daEl = document.getElementById('daInput');
    if (daEl) daEl.value = t.start_address;
    const aEl = document.getElementById('aInput');
    if (aEl) aEl.value = t.end_address;

    // ── Tipologia luoghi ─────────────────────────────────────────
    const tipoPart = document.getElementById('tipologiaPartenza');
    if (tipoPart) tipoPart.value = t.start_address_opts.type || '';
    const tipoArr = document.getElementById('tipologiaArrivo');
    if (tipoArr) tipoArr.value = t.end_address_opts.type || '';

    // ── Passeggeri (step 2) ──────────────────────────────────────
    const cInput = document.getElementById('carrozzinaInput');
    if (cInput) cInput.value = t.seat;
    const acInput = document.getElementById('accompagnatoriInput');
    if (acInput) acInput.value = t.seat_guest;

    fetchRouteMap();
    console.info('[ENV] Modalità TEST attiva — form precompilato');
}

document.addEventListener('DOMContentLoaded', function () {

    // ── Ritorno da pagamento redirect (PayPal, iDEAL, …) ─────────
    // Dati salvati in localStorage da executeRedirectPayment() prima del redirect.
    const _rawPending = localStorage.getItem('pendingRedirectPayment');
    if (_rawPending) {
        localStorage.removeItem('pendingRedirectPayment');

        let _pending = null;
        try { _pending = JSON.parse(_rawPending); } catch (_) {}

        const _piId    = _pending?.paymentIntentId    || '';
        const _method  = _pending?.paymentMethodLabel || 'PayPal';
        const _resType = _pending?.reservationType    || '';
        const _total   = _pending?.total              || '';

        // Ripristina BookingState dallo snapshot
        if (_pending?.bookingState) {
            try { Object.assign(BookingState, _pending.bookingState); } catch (_) {}
        }
        BookingState.paymentMethodLabel = _method;

        // Pulisci eventuali parametri Stripe dall'URL
        window.history.replaceState({}, document.title, window.location.pathname);

        // Mostra spinner mentre si registra la prenotazione
        const _main = document.querySelector('main');
        if (_main) {
            _main.innerHTML = `
              <div style="max-width:650px;width:100%;padding:60px 20px;margin:0 auto;text-align:center;">
                <div class="spinner-border mb-4" role="status"
                     style="width:3rem;height:3rem;color:#0e1f3b;"></div>
                <h4 class="fw-bold mb-2" style="color:#0e1f3b;">Registrazione prenotazione…</h4>
                <p class="text-muted">Il pagamento è confermato, stiamo finalizzando la tua prenotazione.</p>
              </div>`;
        }

        // Costruisci il payload completo (stesso di executePayment ma con PI già confermato)
        const _payload = { ...BookingState.Summary };
        _payload.client                     = { ...BookingState.client };
        _payload.fly_number                 = BookingState.fly_number;
        _payload.train_name                 = BookingState.train_name;
        _payload.boat_name                  = BookingState.boat_name;
        _payload.PaymentMethod              = BookingState.PaymentMethod || '';
        _payload.confirmed_payment_intent_id = _piId;

        // Riprova fino a 3 volte (il PI potrebbe essere ancora in processing)
        (function _register(attempt) {
            api.execItem('outreach.paymentReservation', _payload, 'cron:1').then(res => {
                if (res?.result?.reservation) {
                    track('booking_payment_success', {
                        reservation_type: _resType,
                        payment_method:   _method,
                        total:            _total,
                        reservation_id:   res.result.reservation?.id || '',
                    });
                    showThankYouPage();
                } else if (attempt < 3) {
                    setTimeout(() => _register(attempt + 1), 2000);
                } else {
                    const errMsg = res?.result?.errorInfo || 'Errore nella registrazione della prenotazione.';
                    if (_main) {
                        _main.innerHTML = `
                          <div style="max-width:650px;width:100%;padding:60px 20px;margin:0 auto;text-align:center;">
                            <p class="fw-bold mb-3" style="color:#dc3545;">${errMsg}</p>
                            <p class="text-muted mb-4">Il pagamento è andato a buon fine. Contatta il supporto per completare la prenotazione.<br>
                            <a href="tel:${ENV.CONTACT_PHONE}" class="fw-bold">${ENV.CONTACT_PHONE}</a></p>
                            <button class="btn text-white rounded-3 px-4 py-2"
                                    style="background:#0e1f3b;"
                                    onclick="window.location.href=window.location.pathname">
                              Torna alla prenotazione
                            </button>
                          </div>`;
                    }
                }
            });
        })(1);

        return;
    }

    // Aggiunge ID agli elementi HTML che ne sono privi
    initDomIds();

    // Inietta il widget di disponibilità nello step 1
    injectAvailabilityWidget();

    // Mostra il primo step e popola i select orari
    showTab(currentTab);
    populateTimes();

    // Datepicker jQuery UI (lingua italiana)
    if (typeof $ !== 'undefined' && $.fn.datepicker) {
        $.datepicker.setDefaults($.datepicker.regional['it']);
        $('#dataPartenza').datepicker({
            dateFormat: 'dd/mm/yy',
            minDate:    1,
            onSelect: function () {
                $('#dataRitorno').datepicker('option', 'minDate', $(this).datepicker('getDate'));
                triggerAvailabilityCheck();
            },
        });
        $('#dataRitorno').datepicker({
            dateFormat: 'dd/mm/yy',
            minDate:    1,
            onSelect:   triggerAvailabilityCheck,
        });
    }

    // Tipo tratta → aggiorna UI e re-check disponibilità
    document.querySelectorAll('input[name="tipoTratta"]').forEach(r => {
        r.addEventListener('change', function () { toggleAndataRitorno(this.value); });
    });

    // Modalità ritorno → aggiorna reservation_type e label orario ritorno
    document.querySelectorAll('input[name="modalitaRitorno"]').forEach(r => {
        r.addEventListener('change', function () {
            collectStep1();
            updateLabelOrarioRitorno(this.value);
        });
    });

    // Cambio orari → trigger check disponibilità
    ['oraPartenza', 'oraRitorno'].forEach(id => {
        document.getElementById(id)?.addEventListener('change', triggerAvailabilityCheck);
    });

    // Precompila il form dai parametri hash (da snipped.html)
    applyHashParams();

    // Applica dati di test se IS_TEST è attivo
    applyTestData();

    // Precarica Stripe.js in background (mount avviene solo nello step 3)
    loadStripeJS(() => {});
});
